<template>
  <div>

    <div class="ps-shopping">
      <h3 class="ps-shopping__title">
        Xüsusi günlər
      </h3>

      <p class="text-dark">
        Xüsusi günləriniz, məsələn, doğum gününüz, evlilik il dönümünüz və s. kimi günləri qeyd edə bilərsiniz.
        Bu günlərdə sizə xüsusi təkliflər göndərəcəyik.
        <br>
        <strong>Qeyd:</strong> Bu günlər yalnız sizin üçün qeyd olunur və başqaları ilə paylaşılmayacaq.
      </p>


      <div class=" row my-4">

        <div class="col-md-8">
          <div class="alert alert-info" v-if="days.length<1">
            Sizin xüsusi günləriniz yoxdur. <br>
          </div>
          <div class="row">

            <div class="col-md-6 mb-5" v-for="a in days" :key="a.id">
              <div class="card">
                <div class="card-body">
                  <strong>{{ a.name }}</strong> <br>
                   <span>{{a.day}} {{getMonthName(a.month)}}</span>
                  <br>
                  <span>
                    {{a.description}}
                  </span>


                  <br>
                  <button class="btn btn-primary mt-3 mr-3" @click.prevent="editingDay=a">
                    düzəliş et
                  </button>
                  <button class="btn btn-danger mt-3" @click.prevent="deleteAddress(a.id)">
                    tarixi sil
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="card">
            <div class="card-header">
              <strong>Xüsusi gün əlavə et</strong>
            </div>
            <div class="card-body">
              <AddSpecialDayForm @dayCreated="loadSpecialDayList"/>
            </div>
          </div>
        </div>


      </div>

    </div>
  </div>


  <modal-slot :isVisible="editingDay" title="" modalSize="md"
              @modalClose="editingDay= null">

    <div class="p-3">

      <h3>
        Xüsusi günə düzəliş et
      </h3>

      <EditSpecialDayForm :special-day="editingDay"
                          @dayUpdated="dayUpdated"
                          @modalClose="editingDay = null"/>

    </div>

  </modal-slot>
</template>

<script>
import {mapState} from 'vuex';
import {baseUrl} from '@/repositories/Repository';
 import {deleteSpecialDay, getSpecialDayList} from "@/repositories/UserRepository";
import AddSpecialDayForm from "@/components/layout/AddSpecialDayForm.vue";
import ModalSlot from "@/components/layout/ModalSlot.vue";
import EditSpecialDayForm from "@/components/layout/EditSpecialDayForm.vue";

export default {
  layout: 'default',
  components: {EditSpecialDayForm, ModalSlot, AddSpecialDayForm},
  data() {
    return {
      baseDomain: baseUrl,
      days: [],
      editingDay: null,
    }
  },
  computed: {
    ...mapState({
      user: state => state.auth.user,
      token: state => state.auth.token,
    }),
  },
  async created() {

    this.loadSpecialDayList();

    this.$store.commit('app/setLoading', false);
  },
  methods: {
    getMonthName(number){

      if(typeof number !== 'number') {
        number = parseInt(number);
      }

      if (number === 1) return 'Yanvar';
      if (number === 2) return 'Fevral';
      if (number === 3) return 'Mart';
      if (number === 4) return 'Aprel';
      if (number === 5) return 'May';
      if (number === 6) return 'İyun';
      if (number === 7) return 'İyul';
      if (number === 8) return 'Avqust';
      if (number === 9) return 'Sentyabr';
      if (number === 10) return 'Oktyabr';
      if (number === 11) return 'Noyabr';
      if (number === 12) return 'Dekabr';

    },
    loadSpecialDayList() {
      getSpecialDayList(this.token).then((dayList) => {
           this.days = dayList;
       })
    },

    dayUpdated() {
      this.loadSpecialDayList();
      this.editingDay = null;
    },

    deleteAddress(id) {

      console.log('deleteAddress', id);

      if (confirm('Xüsusi günü silmək istədiyinizdən əminsinizmi?')) {

        deleteSpecialDay(this.token, id).then(() => {
             this.loadSpecialDayList();
         });

      }

    }
  }
}
</script>
